import axios from "axios";
import { ChangeRequestStatus } from "../../../modules/constants";
import { handleHttpErrors } from "../../../modules/http";
import { getClaims } from "../../../modules/login";
import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";

// Constants
const LOADING_CHANGE_REQUESTS = "LOADING_CHANGE_REQUESTS";
const SET_CHANGE_REQUESTS = "SET_CHANGE_REQUESTS";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getChangeRequests = (state) => state?.changeRequests;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;
const getLoading = (state) => state?.loading;

const canApproveChangeRequest = (state) =>
  getClaims(state, "mealLog.changeRequest.canApprove");
const canViewDetailChangeRequest = (state) =>
  getClaims(state, "mealLog.changeRequest.detail.canView");

// Default state
const initialState = {
  changeRequests: [],
  totalItems: null,
  loading: false,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    search: "",
    orderBy: "createdAt",
    order: orderType.DESC,
    filter: ChangeRequestStatus.OPEN.id,
  },
};

export const changeRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CHANGE_REQUESTS:
      return {
        ...state,
        loading: true,
      };
    case SET_CHANGE_REQUESTS:
      const { changeRequests, records } = action;
      return {
        ...state,
        changeRequests: changeRequests,
        totalItems: records,
        searchedParams: action.searchedParams,
        loading: false,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchChangeRequests = (searchedParams) => (dispatch) => {
  const params = {
    ...searchedParams,
  };

  dispatch({
    type: LOADING_CHANGE_REQUESTS,
  });

  return axios
    .get(`/api/diet/changerequest/list`, { params })
    .then(({ data }) => {
      dispatch({
        type: SET_CHANGE_REQUESTS,
        changeRequests: data.data,
        records: data.records,
        searchedParams,
      });
    })
    .catch((error) => {
      // if statement to avoid to show an error when the request is canceled
      if (error?.message === "cancel") {
        return;
      }

      const defaultMessage = error.response?.data
        ? error.response.data
        : "There was an error while trying to fetch change requests!";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

export const mapStateToProps = (state) => {
  return {
    changeRequests: getChangeRequests(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
    canViewDetailChangeRequest: canViewDetailChangeRequest(state),
    canApproveChangeRequest: canApproveChangeRequest(state),
    loading: getLoading(state),
  };
};

export const mapDispatchToProps = {
  fetchChangeRequests,
  resetState,
};
